module.exports = __webpack_public_path__ + "static/larsseit-regular-9de28b57d9c49c8c7ab4c5d273b110f6.woff2";